import React from "react";
import FullLayout from "@/layouts/FullLayout";
import { Link } from "react-router";
import { linkButtonClasses } from "../helpers/style.helpers";
import { useAppContext } from "@/context/AppContext";
import { useScannerContext } from "@/features/scanners/ScannerContext";
import { WEB_SERIAL_SCANNER_FRIENDLY_NAME } from "@/features/scanners/WebSerialScanner";
import { scannerMenuItems } from "@/features/navigation/menuItems";

export function AppMenu() {
  const { markVisitedHome } = useAppContext();
  const { selectedScanner, enableScanner } = useScannerContext();
  const cls = `${linkButtonClasses} text-center capitalize`;
  const cls2 = `${linkButtonClasses} text-center capitalize bg-gray-500`;
  const [showTestLinks, setShowTestLinks] = React.useState(false);

  const scannerTypeLabel = React.useMemo(() => {
    if (!selectedScanner) {
      return "Geen scanner geselecteerd";
    }

    if (selectedScanner.friendlyName === WEB_SERIAL_SCANNER_FRIENDLY_NAME) {
      return "Web API (USB scanner)";
    }

    const isEnterpriseBrowser = typeof window !== "undefined" && typeof window.EB !== "undefined";

    if (isEnterpriseBrowser) {
      return `Enterprise Browser (${selectedScanner.friendlyName})`;
    }

    return `Overig (${selectedScanner.friendlyName})`;
  }, [selectedScanner]);

  const mainMenuItems = React.useMemo(() => scannerMenuItems.filter((item) => !item.isDeveloperOnly), []);
  const developerMenuItems = React.useMemo(() => scannerMenuItems.filter((item) => item.isDeveloperOnly), []);

  // The kwc scan components will redirect back to the app menu if the scan was successful.
  // But the components should only navigate back if the user has already visited the "/" route.
  React.useEffect(() => {
    markVisitedHome();
  }, [markVisitedHome]);

  React.useEffect(() => {
    if (selectedScanner?.friendlyName !== WEB_SERIAL_SCANNER_FRIENDLY_NAME) {
      void enableScanner(true);
    }
  }, [enableScanner, selectedScanner]);

  return (
    <FullLayout>
      <div className="flex flex-col gap-4 justify-center">
        <div className="rounded bg-white px-4 py-3 text-center text-sm text-blue-900 shadow-sm">
          Scan een navigatie QR-code of kies hieronder een knop.
        </div>
        {mainMenuItems.map((item) => (
          <Link key={item.id} to={item.path} className={cls}>
            {item.label}
          </Link>
        ))}
        {!showTestLinks && (
          <>
            <button
              className="mt-4"
              onClick={() => {
                setShowTestLinks(true);
              }}
            >
              <small>show developer links</small>
            </button>
            <div className="text-center text-xs text-gray-700">
              Actieve scanner: <span className="font-semibold">{scannerTypeLabel}</span>
            </div>
          </>
        )}
        {showTestLinks && (
          <>
            {developerMenuItems.map((item) => (
              <Link key={item.id} to={item.path} className={cls2}>
                {item.label}
              </Link>
            ))}
          </>
        )}
      </div>
    </FullLayout>
  );
}

export default AppMenu;
